var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#E1F800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1261 23.369V23.0182C21.1261 18.7944 21.1239 14.5706 21.1195 10.3468C21.1195 10.0727 21.1815 9.99604 21.4616 10.0007C22.4586 10.0194 23.457 10.0214 24.4541 10.0007C24.7628 9.99404 24.8589 10.0561 24.8582 10.3895C24.8449 14.5791 24.8489 18.7693 24.8489 22.9589V23.329C25.0042 23.2776 25.0689 23.1709 25.1503 23.0889C26.7745 21.4683 28.3959 19.8455 30.0148 18.2204C30.1815 18.053 30.2675 18.0203 30.4509 18.2104C31.1845 18.9674 31.9301 19.709 32.6831 20.4459C32.8371 20.5966 32.8378 20.678 32.6831 20.8321C29.5037 24.0012 26.3292 27.1753 23.1596 30.3542C23.0135 30.5003 22.9355 30.523 22.7754 30.3629C19.5987 27.175 16.4169 23.9926 13.2299 20.8154C13.0885 20.6747 13.0752 20.604 13.2252 20.4572C13.9864 19.713 14.7389 18.9605 15.4827 18.1997C15.6421 18.0363 15.7228 18.0283 15.8896 18.1997C17.5279 19.8523 19.1719 21.5003 20.8214 23.1436C20.8978 23.2345 20.9661 23.3321 21.0254 23.435L21.1261 23.369Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9996 32.2668C27.2114 32.2668 31.4229 32.2644 35.6343 32.2595C35.931 32.2595 36.0051 32.3362 35.9997 32.6277C35.9811 33.6467 35.9857 34.6664 35.9997 35.6861C35.9997 35.9195 35.9624 36.0122 35.6963 36.0116C27.2292 36.0044 18.762 36.0044 10.2949 36.0116C10.0601 36.0116 9.99746 35.9449 10.0001 35.7141C10.0115 34.6724 10.0148 33.63 10.0001 32.5883C9.99613 32.3175 10.0828 32.2622 10.3369 32.2628C14.5563 32.2695 18.7772 32.2708 22.9996 32.2668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuSign);
export default __webpack_public_path__ + "static/media/DocuSign.e20446e8cd4639633bfb2cfe5a66c555.svg";
export { ForwardRef as ReactComponent };